(function () {
  const CONTAINER_SELECTOR = '[class*="--apple-pay-only"]';
  const APPLE_PAY_SELECTOR =
    'apple-pay-button, shopify-apple-pay-button, [aria-label*="Apple Pay"], [aria-label*="Apple pay"]';

  function isApplePayNode(node) {
    if (!node) return false;

    return node.matches?.(APPLE_PAY_SELECTOR) || Boolean(node.querySelector?.(APPLE_PAY_SELECTOR));
  }

  function parseWalletConfig(value, fallback = null) {
    try {
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  }

  function hideElement(element) {
    if (element.style.getPropertyValue('display') !== 'none') {
      element.style.setProperty('display', 'none', 'important');
    }
    if (!element.hidden) element.hidden = true;
    if (element.getAttribute('aria-hidden') !== 'true') {
      element.setAttribute('aria-hidden', 'true');
    }
  }

  function showElement(element) {
    if (element.style.getPropertyValue('display')) {
      element.style.removeProperty('display');
    }
    if (element.hidden) element.hidden = false;
    if (element.hasAttribute('aria-hidden')) {
      element.removeAttribute('aria-hidden');
    }
  }

  function trimCartSkeleton(host) {
    host.querySelectorAll('[data-shopify-buttoncontainer]').forEach((list) => {
      [...list.children].slice(1).forEach((item) => item.remove());
    });
  }

  function restrictCartHost(host) {
    const configs = parseWalletConfig(host.getAttribute('wallet-configs'), []);
    const applePayConfig = configs.find((config) => config?.name === 'apple_pay');

    if (!applePayConfig) {
      host.dataset.applePayFiltered = 'false';
      hideElement(host);
      return null;
    }

    if (configs.length === 1 && configs[0]?.name === 'apple_pay') {
      host.dataset.applePayFiltered = 'true';
      trimCartSkeleton(host);
      showElement(host);
      return host;
    }

    const replacement = host.cloneNode(true);
    replacement.dataset.applePayFiltered = 'true';
    replacement.setAttribute('wallet-configs', JSON.stringify([applePayConfig]));
    trimCartSkeleton(replacement);
    host.replaceWith(replacement);
    showElement(replacement);
    return replacement;
  }

  function restrictProductHost(host) {
    const recommended = parseWalletConfig(host.getAttribute('recommended'));
    const fallback = parseWalletConfig(host.getAttribute('fallback'));
    const applePayConfig = [recommended, fallback].find((config) => config?.name === 'apple_pay');

    if (!applePayConfig) {
      host.dataset.applePayFiltered = 'false';
      hideElement(host);
      return null;
    }

    if (recommended?.name === 'apple_pay' && !fallback) {
      host.dataset.applePayFiltered = 'true';
      showElement(host);
      return host;
    }

    const replacement = host.cloneNode(true);
    replacement.dataset.applePayFiltered = 'true';
    replacement.setAttribute('recommended', JSON.stringify(applePayConfig));
    replacement.removeAttribute('fallback');
    host.replaceWith(replacement);
    showElement(replacement);
    return replacement;
  }

  function filterLegacyWallets(container) {
    container.querySelectorAll('[aria-label]').forEach((element) => {
      const label = element.getAttribute('aria-label') || '';
      if (/apple pay/i.test(label)) {
        showElement(element);
      } else if (/shop pay|google pay|paypal/i.test(label)) {
        hideElement(element);
      }
    });

    container
      .querySelectorAll('.dynamic-checkout__content ul > li, [data-shopify-buttoncontainer] > li')
      .forEach((item) => {
        if (isApplePayNode(item)) showElement(item);
      });
  }

  function filterApplePayOnly(container) {
    [...container.querySelectorAll('shopify-accelerated-checkout-cart')].forEach(restrictCartHost);
    [...container.querySelectorAll('shopify-accelerated-checkout')].forEach(restrictProductHost);
    filterLegacyWallets(container);

    const hasApplePay =
      Boolean(container.querySelector('[data-apple-pay-filtered="true"]')) ||
      Boolean(container.querySelector(APPLE_PAY_SELECTOR));
    container.hidden = !hasApplePay;
  }

  function observeContainer(container) {
    filterApplePayOnly(container);

    if (container.dataset.applePayFilterBound === 'true') return;
    container.dataset.applePayFilterBound = 'true';

    new MutationObserver(() => filterApplePayOnly(container)).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'wallet-configs', 'recommended', 'fallback'],
    });
  }

  function initApplePayOnly() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(observeContainer);
  }

  document.addEventListener('DOMContentLoaded', initApplePayOnly);
  document.addEventListener('shopify:section:load', initApplePayOnly);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(initApplePayOnly));
  }

  if (window.Shopify?.PaymentButton?.init) {
    const originalInit = window.Shopify.PaymentButton.init.bind(window.Shopify.PaymentButton);
    window.Shopify.PaymentButton.init = function (...args) {
      const result = originalInit(...args);
      initApplePayOnly();
      return result;
    };
  }

  const cartDrawer = document.querySelector('cart-drawer.cart-drawer--vaillant');
  if (cartDrawer) {
    new MutationObserver(() => {
      if (cartDrawer.classList.contains('active')) initApplePayOnly();
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
})();
